import { Rule } from "@siteimprove/alfa-act";
import { Technique } from "@siteimprove/alfa-wcag";
import { video } from "../common/applicability/video.js";
import { videoDescriptionTrackAccurate } from "../common/expectation/video-description-track-accurate.js";
import { Scope, Stability } from "../tags/index.js";
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r34",
    requirements: [Technique.of("H96")],
    tags: [Scope.Component, Stability.Deprecated],
    evaluate({ device, document }) {
        return {
            applicability() {
                return video(document, device, {
                    audio: { has: false },
                    track: { has: true, kind: "descriptions" },
                });
            },
            expectations(target) {
                return videoDescriptionTrackAccurate(target);
            },
        };
    },
});
//# sourceMappingURL=rule.js.map